import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const AIApplication = () => (
  <div className="service-page">
    <Navbar />
    <div className="service-hero">
      <h1>AI Application &amp; Pipeline Implementation</h1>
      <p>End-to-end artificial intelligence solutions — from data ingestion and model training to production deployment and ongoing optimisation.</p>
    </div>

    <div className="service-content">
      <div className="service-grid">
        <div className="service-card">
          <div className="icon">🔧</div>
          <h2>AI Pipeline Architecture</h2>
          <p>
            We design and implement scalable AI/ML pipelines that automate the entire lifecycle —
            from raw data collection through feature engineering, model training, evaluation,
            deployment, and monitoring.
          </p>
          <ul>
            <li>Distributed data ingestion &amp; preprocessing</li>
            <li>Feature store design for reusability</li>
            <li>Automated model training &amp; hyperparameter tuning</li>
            <li>Model registry, versioning &amp; A/B testing</li>
            <li>Real-time inference endpoints (REST, gRPC, streaming)</li>
            <li>Drift detection &amp; automated retraining</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">🧠</div>
          <h2>Natural Language Processing</h2>
          <p>
            Unlock insights from text with custom NLP solutions. We build, fine-tune, and deploy
            language models for classification, extraction, generation, and conversation.
          </p>
          <ul>
            <li>Sentiment analysis &amp; intent classification</li>
            <li>Named entity recognition (NER) &amp; information extraction</li>
            <li>Custom chatbot &amp; virtual assistant pipelines</li>
            <li>Document summarisation &amp; question answering</li>
            <li>Multi-language support &amp; translation</li>
            <li>Fine-tuning of large language models (LLMs)</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">👁️</div>
          <h2>Computer Vision</h2>
          <p>
            Build visual intelligence into your applications. From object detection to
            image generation, we deliver production-grade computer vision solutions.
          </p>
          <ul>
            <li>Object detection, segmentation &amp; tracking</li>
            <li>Optical character recognition (OCR) &amp; document parsing</li>
            <li>Image classification &amp; quality inspection</li>
            <li>Facial recognition &amp; liveness detection</li>
            <li>Video analytics &amp; anomaly detection</li>
            <li>Generative image models (diffusion, GANs)</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">📊</div>
          <h2>Predictive Analytics</h2>
          <p>
            Turn historical data into forward-looking intelligence. Our predictive models
            help you forecast demand, detect anomalies, and optimise decisions.
          </p>
          <ul>
            <li>Time-series forecasting (demand, revenue, traffic)</li>
            <li>Anomaly &amp; fraud detection systems</li>
            <li>Customer churn &amp; lifetime value prediction</li>
            <li>Recommendation engines &amp; personalisation</li>
            <li>Risk scoring &amp; credit modelling</li>
            <li>Explainable AI (SHAP, LIME) for regulatory compliance</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">☁️</div>
          <h2>MLOps &amp; Deployment</h2>
          <p>
            Bridge the gap between data science and production. We operationalise machine
            learning with robust infrastructure, CI/CD pipelines, and observability.
          </p>
          <ul>
            <li>Cloud-native ML infrastructure (AWS, GCP, Azure)</li>
            <li>Containerised model serving (Docker, Kubernetes)</li>
            <li>CI/CD for ML pipelines (DVC, MLflow, Kubeflow)</li>
            <li>Model monitoring, logging &amp; alerting</li>
            <li>Cost optimisation for inference workloads</li>
            <li>On-premise &amp; edge deployment options</li>
          </ul>
        </div>

        <div className="service-card">
          <div className="icon">🔗</div>
          <h2>Integration &amp; API Layer</h2>
          <p>
            Seamlessly embed AI into your existing workflows. Every model comes with
            clean APIs, webhook support, and easy integration into your stack.
          </p>
          <ul>
            <li>RESTful &amp; gRPC inference APIs</li>
            <li>Event-driven pipelines (Kafka, RabbitMQ)</li>
            <li>Batch processing for large-scale offline inference</li>
            <li>SDKs &amp; client libraries for popular languages</li>
            <li>Authentication, rate-limiting &amp; usage tracking</li>
            <li>Custom dashboard &amp; reporting tools</li>
          </ul>
        </div>
      </div>
    </div>

    <div className="service-cta">
      <h2>Let's build intelligent systems together</h2>
      <p>From proof-of-concept to production — we deliver AI that works at scale.</p>
      <a href="mailto:kwuimi@qmxtechnology.com" className="cta">Get in Touch</a>
    </div>

    <Footer />
  </div>
);

export default AIApplication;
